import React from 'react';

// ConceptModal Component - Extracted from App.js for better maintainability
// Displays detailed information about a selected security concept in a modal overlay

const ConceptModal = ({ 
  selectedConcept, 
  onClose, 
  bookmarkedConcepts, 
  toggleBookmark 
}) => {
  if (!selectedConcept) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      onClick={handleBackdropClick}
    >
      <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto focus:outline-none" tabIndex={-1}>
        <div className="p-6">
          <div className="flex justify-between items-start mb-4">
            <h2 id="modal-title" className="text-2xl font-bold text-gray-800">{selectedConcept.title}</h2>
            <div className="flex items-center space-x-2">
              <button
                onClick={() => toggleBookmark(selectedConcept.key)}
                className={`p-2 rounded-lg transition-colors ${
                  bookmarkedConcepts.has(selectedConcept.key)
                    ? 'bg-yellow-100 text-yellow-600 hover:bg-yellow-200'
                    : 'bg-gray-100 text-gray-500 hover:bg-gray-200'
                }`}
                title={bookmarkedConcepts.has(selectedConcept.key) ? 'Remove bookmark' : 'Add bookmark'}
              >
                {bookmarkedConcepts.has(selectedConcept.key) ? '★' : '☆'}
              </button>
              <button
                onClick={onClose}
                className="text-gray-500 hover:text-gray-700 text-2xl"
              >
                ×
              </button>
            </div>
          </div>
          
          <div className="space-y-6">
            <div>
              <h3 className="text-lg font-semibold text-blue-600 mb-2">Explanation</h3>
              <p id="modal-description" className="text-gray-700">{selectedConcept.explanation}</p>
            </div>
            
            <div>
              <h3 className="text-lg font-semibold text-green-600 mb-2">Examples</h3>
              <p className="text-gray-700">{selectedConcept.examples}</p>
            </div>
            
            {selectedConcept.useCase && (
              <div>
                <h3 className="text-lg font-semibold text-gray-800 mb-2">🏢 Use Case</h3>
                <p className="text-gray-700 whitespace-pre-line">{selectedConcept.useCase}</p>
              </div>
            )}
            
            <div>
              <h3 className="text-lg font-semibold text-purple-600 mb-2">Memory Aid</h3>
              <p className="text-gray-700 whitespace-pre-line">{selectedConcept.mnemonic}</p>
            </div>
            
            <div>
              <h3 className="text-lg font-semibold text-orange-600 mb-2">Visual Diagram</h3>
              <pre className="bg-gray-100 p-4 rounded text-sm font-mono overflow-x-auto">
{selectedConcept.visual}
              </pre>
            </div>
          </div>
          
          <div className="mt-6 flex justify-end">
            <button
              onClick={onClose}
              className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition-colors"
            >
              Got it!
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(ConceptModal);